// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__R9c16","container2":"Carousel_container2__9jh-O","texto2":"Carousel_texto2__XbWrM"};